import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import VerticalTabs from 'components/VerticalTabs';
import { isReverse, translate } from 'helpers/intl';
import { sanlamBlue, sanlamVeryDarkBlue } from 'Material-UI/colors';
import messages from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/MyguaranteesBloc/messages';
import {
  SizedSmallSectionHeader,
  ColoredDivider,
} from 'containers/MyguaranteesBloc/styles';
import { Box, Grid, Hidden } from '@material-ui/core';
import CustomizedAccordion from 'components/CustomizedAccordion';
import {
  AccordionDetailsCaptions,
  ItemWrapper,
  StyledCaptions,
} from 'containers/MRHDetailsPage/PreventionGuide/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsLoadingVimeoThumbnailSrcSelector,
  getVimeoThumbnailSrcErrorMessageSelector,
  getVimeoThumbnailSrcSelector,
} from 'store/global/selectors';
import { getVimeoThumbnailSrc } from 'store/global/actions';
import { getVideoIdFormUrl } from 'utils/string';
import VimeoThumbnail from 'components/VimeoThumbnail';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

export const VideoItem = ({
  id,
  title,
  expanded,
}: {
  id: string;
  title: string;
  expanded: boolean | number;
}) => {
  const dispatch = useDispatch();
  const vimeoThumbnailSrc = useSelector(getVimeoThumbnailSrcSelector);
  const isLoadingVimeoThumbnailSrc = useSelector(
    getIsLoadingVimeoThumbnailSrcSelector,
  );
  const vimeoThumbnailSrcErrorMessage = useSelector(
    getVimeoThumbnailSrcErrorMessageSelector,
  );

  useEffect(() => {
    dispatch(getVimeoThumbnailSrc(getVideoIdFormUrl(id)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <VimeoThumbnail
      vimeoThumbnailSrc={vimeoThumbnailSrc}
      videoId={getVideoIdFormUrl(id)}
      isLoadingThumbnail={isLoadingVimeoThumbnailSrc}
      thumbnailErrorMessage={vimeoThumbnailSrcErrorMessage}
      title={title}
    />
  );
};

const ResponsiveGaranties = (props: any) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const [expanded, setExpanded] = useState<boolean | number>(false);

  const handleChange = (index: number) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? index : false);
  };
  return (
    <>
      <Hidden xsDown>
        <VerticalTabs items={props.items} />
      </Hidden>
      <Hidden smUp>
        <Grid spacing={1} direction="column" container>
          {props.items.map((item: any, index: number) => (
            <Grid key={index} item xs>
              <CustomizedAccordion
                expanded={expanded === index}
                changeHandler={handleChange(index)}
                summary={
                  <ItemWrapper reverse={reverse}>
                    <StyledCaptions
                      weight="500"
                      color={
                        index === expanded ? sanlamBlue : sanlamVeryDarkBlue
                      }
                    >
                      {item.title}
                    </StyledCaptions>
                  </ItemWrapper>
                }
                details={
                  <Box paddingX={3}>
                    <AccordionDetailsCaptions weight="400">
                      {item.description}
                    </AccordionDetailsCaptions>

                    {item.video && (
                      <Box marginY={2}>
                        <VideoItem
                          id={item.video}
                          title={item.title}
                          expanded={expanded}
                        />
                      </Box>
                    )}
                  </Box>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Hidden>
    </>
  );
};

const MyguaranteesBloc: React.FC<{
  intl: IntlShape;
  garanties: any[];
  isLoadingDetailContract: boolean;
}> = (props) => {
  return (
    <React.Fragment>
      {props.garanties ? (
        <>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate(messages.MyguaranteesBlocTitle, props)}
            {`(${get(props, 'garanties.length', '0')})`}
          </SizedSmallSectionHeader>
          {props.isLoadingDetailContract ? (
            <Skeleton
              data-testid="loader"
              variant="rect"
              width={767}
              height={154}
            />
          ) : (
            <ResponsiveGaranties items={props.garanties} />
          )}
          <ColoredDivider orientation="horizontal" />
        </>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default injectIntl(MyguaranteesBloc);
